module.exports = __webpack_public_path__ + "img/logo.0cbe9b96.png";